/* BJ CUSTOM: boční košík po přidání do košíku.
   Volá se z product-form.js: window.bjCartDrawer.open(addResponse, prvekProNávratFokusu) */
(function () {
  class BjCartDrawer {
    constructor(el) {
      // Přesun do <body>: sticky header se při scrollu posouvá přes transform,
      // což by rozbilo position: fixed, kdyby drawer zůstal uvnitř hlavičky.
      document.body.appendChild(el);

      this.el = el;
      this.panel = el.querySelector('.bj-cart-drawer__panel');
      this.itemEl = el.querySelector('[data-bj-item]');
      this.subtotalEl = el.querySelector('[data-bj-subtotal]');
      this.viewCartEl = el.querySelector('[data-bj-view-cart]');
      this.moneyFormat = el.dataset.moneyFormat || '';
      this.shopCurrency = el.dataset.shopCurrency || '';
      this.locale = el.dataset.locale || document.documentElement.lang || 'cs';
      this.viewCartLabel = el.dataset.viewCartLabel || '';
      this.returnFocusTo = null;

      el.querySelectorAll('[data-bj-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
      this.onKeyUp = (e) => {
        if (e.key === 'Escape') this.close();
      };
    }

    async open(added, returnFocusTo) {
      this.returnFocusTo = returnFocusTo || document.activeElement;
      const item = added && added.items ? added.items[0] : added;

      let cart = null;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        cart = await res.json();
      } catch (e) {
        console.error('BjCartDrawer: nepodařilo se načíst košík', e);
      }

      const line = cart && item ? cart.items.find((i) => i.key === item.key) : null;
      this.renderItem(line || item, cart ? cart.currency : null);

      if (cart) {
        this.subtotalEl.innerHTML = this.formatMoney(cart.total_price, cart.currency);
        this.updateCounts(cart.item_count);
        this.updateViewCartLabel(cart.item_count);
      }

      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bj-cart-drawer-open');
      document.addEventListener('keyup', this.onKeyUp);
      requestAnimationFrame(() => this.panel.focus());
    }

    close() {
      if (!this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bj-cart-drawer-open');
      document.removeEventListener('keyup', this.onKeyUp);
      if (this.returnFocusTo && typeof this.returnFocusTo.focus === 'function') {
        this.returnFocusTo.focus();
      }
    }

    renderItem(item, currency) {
      this.itemEl.innerHTML = '';
      if (!item) return;

      const wrap = document.createElement('div');
      wrap.className = 'bj-cart-drawer__item';

      if (item.image) {
        const img = document.createElement('img');
        img.className = 'bj-cart-drawer__image';
        img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=240';
        img.alt = item.product_title || '';
        img.width = 88;
        img.height = 88;
        wrap.appendChild(img);
      } else {
        wrap.appendChild(document.createElement('div'));
      }

      const info = document.createElement('div');

      const name = document.createElement('p');
      name.className = 'bj-cart-drawer__name';
      const link = document.createElement('a');
      link.href = item.url || '#';
      link.textContent = item.product_title || item.title || '';
      name.appendChild(link);
      info.appendChild(name);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'bj-cart-drawer__meta';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }

      const price = document.createElement('p');
      price.className = 'bj-cart-drawer__price';
      const qty = item.quantity || 1;
      const linePrice = item.final_line_price != null ? item.final_line_price : item.final_price * qty;
      price.innerHTML =
        (qty > 1 ? qty + ' × ' : '') + this.formatMoney(qty > 1 ? item.final_price : linePrice, currency);
      info.appendChild(price);

      wrap.appendChild(info);
      this.itemEl.appendChild(wrap);
    }

    updateViewCartLabel(count) {
      if (!this.viewCartLabel || !this.viewCartEl) return;
      // Když chybí překlad, necháme původní text tlačítka.
      if (this.viewCartLabel.toLowerCase().includes('translation missing')) return;
      this.viewCartEl.textContent = this.viewCartLabel.replace('__COUNT__', count);
    }

    // Aktualizace všech počítadel v custom hlavičce (nahrazuje původní jQuery kód).
    updateCounts(count) {
      const desktopSpans = document.querySelectorAll('#cart a span');
      if (desktopSpans.length) desktopSpans[desktopSpans.length - 1].textContent = count;

      document.querySelectorAll('.mob-cart a span').forEach((s) => (s.textContent = count));

      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      let bubble = icon.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          icon.appendChild(bubble);
        }
        const visible = bubble.querySelector('span[aria-hidden]');
        if (visible) visible.textContent = count < 100 ? count : '99+';
      } else if (bubble) {
        bubble.remove();
      }
    }

    formatMoney(cents, currency) {
      const value = (cents || 0) / 100;

      // Jiná měna než základní měna obchodu (Markets): použijeme formát prohlížeče.
      if (currency && this.shopCurrency && currency !== this.shopCurrency) {
        try {
          return new Intl.NumberFormat(this.locale, { style: 'currency', currency }).format(value);
        } catch (e) {
          return value.toFixed(2) + ' ' + currency;
        }
      }

      const num = (n, decimals, thousands, decimal) => {
        const parts = n.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      };

      const format = this.moneyFormat || '{{amount}}';
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return num(value, 0, ',', '.');
          case 'amount_with_comma_separator': return num(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
          case 'amount_with_space_separator': return num(value, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return num(value, 0, ' ', ',');
          case 'amount_with_apostrophe_separator': return num(value, 2, "'", '.');
          default: return num(value, 2, ',', '.');
        }
      });
    }
  }

  function init() {
    const el = document.getElementById('BjCartDrawer');
    if (el && !window.bjCartDrawer) window.bjCartDrawer = new BjCartDrawer(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
